// --------------------------------------------------------------
// Created On: 2026-03-23
// Author: Dimitra Weinstein
//
// Last Modified: 2026-03-24
// Modified By: Dimitra Weinstein
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { useState } from "react";
import Modal from "src/components/Modal/Modal";
import ModalBody from "src/components/ModalBody/ModalBody";
import styles from "./CreateSubsidiaryModal.module.scss";
import ModalHeader from "src/components/ModalHeader/ModalHeader";
import ModalFooter from "src/components/ModalFooter/ModalFooter";

export default function CreateSubsidiaryModal(props: Props): Component {
  const [companyName, setCompanyName] = useState<string>("");

  function closeModal(): void {
    setCompanyName("");
    props.onClose();
  }

  return (
    <Modal
      show={props.showModal}
      onHide={() => {
        //   do nothing
      }}
      backdropClassName={`${styles.modal} ${styles.backdrop}`}
      style={{ zIndex: "var(--modal-z-index)" }}
      size="lg"
      centered
      animation
    >
      <ModalHeader>
        <h5 className="font-weight-bold">Create Subsidiary Company</h5>
      </ModalHeader>
      <ModalBody>
        <div className="row">
          <label className="mb-3 mx-3 fs-6">Subsidiary Company Name</label>
          <div className="col-12 px-4">
            {props.errorMessage && <div className="alert alert-danger">{props.errorMessage}</div>}
            <div className="row px-4 mb-3">
              <input
                type="text"
                className="form-control rounded"
                placeholder="Ex: ABC Subsidiary, LLC"
                onChange={(e) => setCompanyName(e.target.value)}
              />
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="row">
          <div className="col-auto px-4">
            <button
              type="button"
              className="btn btn-primary me-2"
              onClick={() => {
                props.onCreateCompany(companyName);
              }}
              disabled={!companyName.trim()}
            >
              Create Subsidiary
            </button>
            <button type="button" className="btn btn-secondary" onClick={() => closeModal()}>
              Cancel
            </button>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
}

interface Props {
  showModal: boolean;
  errorMessage: string;
  onCreateCompany: (companyName: string) => void;
  onClose: () => void;
}
